<template>
    <v-card outlined hover :href="item.link">
        <v-card-title class="mont-font mont-bold text-left text-wrap text-center">
            {{ item.item }}
        </v-card-title>
        <v-card-text class="mont-font text-left">
            {{ item.itemDescription }}
        </v-card-text>
        <a :href="item.link" target="_blank" rel="noopener noreferrer" class="no-decoration">
            <div v-if="isYouTubeLink(item.link)" class="d-flex justify-center pa-2 mb-4">
                <iframe height="250px" :width="videoWidth" :src="convertToEmbedLink(item.link)"
                    title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>
            </div>
        </a>
    </v-card>
    <v-divider/>
    <div class="d-flex justify-center bg-aqua-teal">
        <v-select label="Status" v-model="status" :items="['Not started', 'In Progress', 'Complete']" outlined compact
            :max-width="300" />
    </div>
</template>

<script>
export default {
    name: "TaskContentCard",
    data() {
        return {
            currentSlide: 0, // Track the current slide
            videoWidth: 'auto',  // Dynamically adjust video width
            status: null
        };
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    emits: ['updateTaskStatus'],
    methods: {
        isYouTubeLink(url) {
            const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)(\/.*)?$/;
            return youtubeRegex.test(url);
        },
        convertToEmbedLink(watchLink) {
            if (watchLink.includes('youtube.com/watch?v=')) {
                return watchLink.replace('watch?v=', 'embed/');
            }
            console.error('Invalid YouTube watch link');
            return null;
        },
        updateVideoWidth() {
            this.videoWidth = `${window.innerWidth / 1.5}px`;
        },
    },
    watch: {
        status(newValue, oldValue) {
            if (oldValue != null) {
                console.log(`Status change: ${newValue}`);

                let task = { ...this.item, status: newValue };
                task["taskCompletionDate"] = (newValue === "Complete") ? new Date() : null;
                this.$emit('updateTaskStatus', task);
            }
        },
        item() {
            console.log(`Item change: ${this.item.item}`);
        }
    },
    mounted() {
        this.status = (this.item) ? this.item.status : null;
        console.log(`Set status: ${this.status}`);
        this.updateVideoWidth();
        window.addEventListener('resize', this.updateVideoWidth);
    },
}
</script>